import { isNull } from 'lodash';
import { getCustomCurrencySymbol } from 'src/utils/utils';
import { Is_Remove_SCVC_Columns } from './new-report-targeting.constant';


export const getCurrency = (currencyCode) => {
  return getCustomCurrencySymbol(currencyCode ? currencyCode : "INR")
}

export const SQP_PERCENTAGE = [
  'IS %', 'searchTermImpressionShare', 'IS_perc',
  'ACOS %', 'ACOS',
  'Ad ACOS %', 'ACOS',
  'My CTR %', 'CTR',
  'T-Clicks %', 'total_click_rate', 
  'B-Clicks %', 'asin_click_share',
  'B-CS %', 'B_CS_perc',
  'ATC-S %', 'asin_cart_add_share',
  'OS %', 'asin_purchase_share',
  'CAT-CR %', 'CR',
  'Cat-CR %', 'CAT_CR_perc',
  'Cat-CTR %', 'CAT_CTR_perc',
  'Cat-ATC %', 'CAT_ATC_perc',
  'Brand Market Share %', 'B-Imp %',
  'asin_click_through_rate', 'non_asin_add_to_cart_rate',
  'asin_cart_adds_rate', 'asin_conversion_rate',
  'order_share','cat_cr_share',
  'cat_ctr_share',
  'Ad B-IS %', 'Ad_IS_perc',
  'B-IS %', 'Total B-IS %', 'T_IS_perc',
  'B-CTR %', 'B_CTR_perc',
  'Ad-CTR %', 'CTR_perc',
  'B-ATCS %', 'B_ATCS_perc',
  'B-ATC %', 'B_ATC_perc',
  'B-OS %', 'O-Share %', 'O_S_Perc',
  'B-CR %', 'B_CR_perc',
  'Ad-CR %', 'CR_perc',
  'Spend_perc', 'Revenue_perc'
]
export const SQP_DECIMAL = [
  'Ad ROAS', 'ROAS'
]
export const SQP_DECIMAL_CURRENCY = [
  'CPC', 'Ad-CPC',
  'B-AOV', 'B_AOV',
  'Ad-AOV', 'AOV'
]
export const SQP_CURRENCY = [
  'Spend', 'Ad Spends',
  'T_AOV',
]
export const SQP_NUMBER = [
  'Search Score', 'search_query_score', 'T_Query', 'T-Query',
  'Search Volume', 'search_query_volume', 'T_Volume',
  'T-Imp', 'total_query_impressions', 'T_Imp',
  'B-Imp', 'asin_impressions', 'B_Imp',
  'Ad-Imp', 'Impressions',
  'Ad IR', 'Ad_IR',
  'T-Clicks', 'total_clicks', 'T_Clicks',
  'B-Clicks', 'asin_clicks', 'B_Clicks',
  'Ad-Clicks', 'Clicks',
  'T-ATC', 'total_cart_adds', 'T_ATC',
  'B-ATC', 'asin_cart_adds', 'B_ATC',
  'T-Orders', 'T_Orders',
  'B-Orders', 'B_Orders',
  'Ad Orders', 'Orders',
  'T-AOV', 'T_AOV',
  'B-AOV', 'B_AOV'
]

export const KPI_DICTIONARY = [
  {
    column_type: 'percentage',
    columns: ['CTR', 'CTR %', 'ACOS', 'Total ACOS %', 'Organic ACOS %', 'Ad ACOS', 'Direct ACOS %', 'InDirect ACOS %', 'Spend %', 'Revenue %', 'CR %', 'Orders %', 'CR', 'Total CR %', 'Direct CR %', 'InDirect CR %', 'Spend %', 'Revenue %', 'Total Revenue %', 'Direct Revenue %', 'InDirect Revenue %', 'Total Rev %', 'Direct Rev %', 'InDirect Rev %', 'IS_perc', 'TOIS_perc', 'api_is_perc', 'API IS %', 'API TOS IS %', 'api_tos_perc', 'CR_perc', 'percentage_of_Orders_NTB', 'percentage_of_sales_NTB', 'ATC %', 'Spend %', 'Ad ACOS %', 'ACOS %', 'IS %', 'searchTermImpressionShare','Last 30D IS%', 'cal_ctr', 'cal_acos', 'cal_t_purchase_rate_percentage', 'Purchases Rate %', 'Unique Reach %', 'Unique NTB Purchases %', 'NTB Rate %', 'TotalACOS', 'DirectACOS', 'InDirectACOS', 'TotalCR', 'DirectCR', 'InDirectCR', 'Rev %', 'ATCPercentage', 'Last 7D Best ACOS %', 'Target ACOS %', 'Last 7D Best ACOS %', 'NTB Order %', 'NTB Sales %', 'ST Purchased Share %','brand_asin_share_purchas','purchase_rate','brand_asin_share_cart','add_to_card_rate', 'brand_asin_share_purchase', 'st_purchase_share', 'Total Budget', 'TotalBudget',  'Budget Utilization', 'CPM_Percentage', 'TACOS', 'Add To Card Rate %', 'Brand ASIN Cart Share %', 'Purchase Rate %', 'Brand ASIN Purchase Share %', 'ST Purchased  Share %', 'CTR %', 'CPM %', 'ACOS%', 'TACOS%', 'CR%', 'total_click_rate', 'asin_click_share', 'asin_cart_add_share', 'total_purchase_rate', 'asin_purchase_share', 'TimeInBudget', 'gst_percentage', 'Avg Ad IS%', 'ads_percentage', 'Avg Organic IS%', 'organic_percentage', 'Best ACOS %', 'SellerACOS', ...SQP_PERCENTAGE]
  },
  {
    column_type: 'decimal',
    columns: ['ROAS', 'Total ROAS', 'TotalROAS', 'Organic ROAS', 'Ad ROAS', 'Direct ROAS', 'InDirect ROAS', 'ATC', 'cal_roas','cal_cost_per_reach','cal_units_per_purchase', 't_sales_roas', ...SQP_DECIMAL]
  },
  {
    column_type: 'decimal_currency',
    columns: ['CPA', 'Total CPA', 'Direct CPA', 'InDirect CPA', 'AOV', 'Total AOV', 'Direct AOV', 'InDirect AOV', 'CPM', 'CPC', 'RPC', 'Bid','cal_cpc', 'SQP Total Purchase', 'Brand ASIN Purchase', 'total_median_click_price', 'asin_median_click_price', 'total_median_cart_add_price', 'asin_median_cart_add_price', 'total_median_purchase_price', 'asin_median_purchase_price', ...SQP_DECIMAL_CURRENCY]
  },
  {
    column_type: 'currency',
    columns: ['GrpSpend', 'Spend', 'Revenue', 'Total Revenue', 'Direct Revenue', 'InDirect Revenue', 'NTB Sales', 'Total Revenue', 'Total_revenue', 'Organic Revenue', 'Organic_revenue','Total Spend', 'Budget', 'Ad Spend', 'Sales', 'Cost', 'TotalCPA', 'DirectROAS', 'InDirectROAS', 'TotalRevenue', 'DirectRevenue', 'InDirectRevenue', 'DirectCPA', 'InDirectCPA', 'TotalAOV', 'DirectAOV', 'InDirectAOV', 'Bidding Price', 'Final Price', 'Bidding_Price', 'Final_Price', 'TotalSpend', 'dailyBudget', 'finalBid', 'Rev', 'suggestedExactBid', 'suggestedPhraseBid', 'suggestedBroadBid', 'amazon_suggested_exact_bid', 'amazon_suggested_expanded_bid', 'Hector Bid', 'brand_asin_purchased', 'sqp_total_purchase','T-Cost','Total Sales','NTB Sales','Repeat Sales','t_cost','t_sales','ntb_t_sales','repeat_t_sales','t_sales_clicks','ntb_t_sales_clicks','repeat_t_sales_clicks','t_sales_views','ntb_t_sales_views','repeat_t_sales_views','sales','ntb_sales','repeat_sales','halo_sales','ntb_halo_sales','repeat_halo_sales','sales_clicks','ntb_sales_clicks','repeat_sales_clicks','halo_sales_clicks','ntb_halo_sales_clicks','repeat_halo_sales_clicks','sales_views','ntb_sales_views','repeat_sales_views', ...SQP_CURRENCY]
  },
  {
    column_type: 'number',
    columns: ['Orders', 'Total Orders', 'Direct Orders', 'InDirect Orders', 'Impressions', 'Clicks', 'CC', 'Total_Impressions', 'Total Revenue', 'Direct Revenue', 'InDirect Revenue', 'CATC',  'Dpv', 'Viewable Impressions', 'Video First Quartile', 'Video Midpoint', 'Video Third Quartile', 'Video Complete', 'Video Unmute', 'Vtr', 'Vctr', 'Add To Cart', 'CC', 'Budget','Last 30D IR', 'search_query_score', 'search_query_volume', 'total_query_impressions', 'asin_impressions', 'brand_asin_share_impression', 'total_clicks', 'asin_clicks', 'total_cart_adds', 'total_cart_add_rate', 'asin_cart_adds', 'total_purchases', 'asin_purchases', 'days_left', ...SQP_NUMBER]
  }
];

const KPI_DICTIONARY_TABLE = [
  {
    column_type: 'percentage',
    columns: ['CTR', 'CTR %', 'ACOS', 'TotalACOS', 'OrganicACOS', 'AdACOS', 'DirectACOS', 'InDirectACOS', 'Spend_perc', 'Revenue_perc', 'CR_perc', 'TotalCR', 'Total CR%', 'DirectCR', 'InDirectCR', 'RevenuePercentage', 'TotalRevenuePercentage', 'DirectRevenuePercentage', 'InDirectRevenuePercentage', 'SpendPercentage', 'CR', 'IS_perc', 'TOIS_perc', 'api_is_perc', 'API IS %', 'API TOS IS %', 'api_tos_perc', 'CR_perc', 'percentage_of_Orders_NTB', 'percentage_of_sales_NTB', 'NTB_Orders_Percentage', 'NTB_Sales_Percentage', 'ATCPercentage', 'ATC_Percentage','TotalSpendPercentage', 'IS %', 'searchTermImpressionShare', 'Last 30D IS%','Viewability Rate %','Viewable Imp CTR %','DPV Rate %','ATC Rate %','Purchase Rate %','NTB Purchase Rate %','NTB Purchase Share %','Repeat Purchase Rate %',' ACOS %','NTB ACOS %',' Repeat ACOS %', 'currentPercentage', 'Last 7D Best ACOS %', 'HECTOR_ACOS', 'TotalBudget', 'total_click_rate', 'asin_click_share', 'asin_cart_add_share', 'total_purchase_rate', 'asin_purchase_share', 'TimeInBudget', 'bestseller_percentage', 'ads_percentage', 'organic_percentage', 'Best ACOS %', 'SellerACOS', ...SQP_PERCENTAGE]
  },
  {
    column_type: 'decimal',
    columns: ['ROAS', 'TotalROAS', 'OrganicROAS', 'AdROAS', 'DirectROAS', 'InDirectROAS', 'CPO', 'ATC','Cost per DPV','Add to Cart', 'Unit per Purchase', 'Cost per reach', ...SQP_DECIMAL]
  },
  {
    column_type: 'decimal_currency',
    columns: ['CPA', 'TotalCPA', 'DirectCPA', 'InDirectCPA', 'AOV', 'TotalAOV', 'DirectAOV', 'InDirectAOV', 'CPM', 'CPC', 'RPC', 'total_median_click_price', 'asin_median_click_price', 'total_median_cart_add_price', 'asin_median_cart_add_price', 'total_median_purchase_price', 'asin_median_purchase_price', ...SQP_DECIMAL_CURRENCY]
  },
  {
    column_type: 'currency',
    columns: ['Spend', 'Revenue', 'TotalRevenue', 'DirectRevenue', 'InDirectRevenue', 'Ad Spend', 'Ad Revenue', 'NTB Sales', 'NTB_Sales', 'Total_revenue', 'Organic_revenue','TotalSpend', 'Budget','T-Cost','Total Sales','Repeat Sales','Cost','T-Cost', 'Bidding_Price', 'Final_Price', 'dailyBudget', 'finalBid', ...SQP_CURRENCY]
  },
  {
    column_type: 'number',
    columns: ['Orders', 'TotalOrders', 'DirectOrders', 'InDirectOrders', 'Impressions', 'Clicks', 'CC', 'Ad Orders', 'CampaignCount', 'Total_Impressions', 'NTB Order', 'TotalRevenue', 'DirectRevenue', 'InDirectRevenue', 'CATC',  'DPV', 'Viewable_Impressions', 'Video_First_Quartile', 'Video_Midpoint', 'Video_Third_Quartile', 'Video_Complete', 'Video_Unmute', 'VTR', 'VCTR', 'AddToCart', 'CampaignCount', 'Budget','Last 30D IR', 'search_query_score', 'search_query_volume', 'total_query_impressions', 'asin_impressions', 'brand_asin_share_impression', 'total_clicks', 'asin_clicks', 'total_cart_adds', 'total_cart_add_rate', 'asin_cart_adds', 'total_purchases', 'asin_purchases', 'days_left', ...SQP_NUMBER]
  }
];

const flipkartProfile =window.location.href.indexOf('flipkart') > -1 ? JSON.parse(sessionStorage.getItem('flipkartProfile')) : {}
const isFlipkartV2 = flipkartProfile && flipkartProfile?.V2 == true

export const PRE_AVAILABLE_COLUMNS_LABELS = (isSupermart = 0) => {
  const amazonProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'))?.profileId;
  const isFlipkart = window.location.href.indexOf('flipkart') > -1;
  const isMyntra = window.location.href.indexOf('myntra') > -1;
  const isBlinkit = window.location.href.indexOf('blinkit') > -1;
  const isAmazonTargeting = window.location.href.indexOf('amazon/targeting') > -1;
  const isInstamart = window.location.href.indexOf('instamart') > -1;
  const isAmazonMarketing = window.location.href.indexOf('amazon/marketing-stream') > -1;
  const isZepto = window.location.href.indexOf('zepto') > -1;
  const flipkartProfile = window.location.href.indexOf('flipkart') > -1 ? JSON.parse(sessionStorage.getItem('flipkartProfile')) : {};
  const isFlipkartV2 = flipkartProfile && flipkartProfile?.V2 == true;
  const isBigbasket = window.location.href.indexOf('bigbasket') > -1;
  const isAmazonSQP = window.location.href.indexOf('amazon/search-query-performance') > -1
  const isAmazonRanking = window.location.href.indexOf('amazon-ranking-dashboard') > -1;

  if (isFlipkart) {
    return [
      {
        title: "Spend",
        name: "Spend", 
        show: "yes"
      },
      {
        title: "Total Revenue",
        name: "Total Revenue",
        show: "yes"
      },
      {
        title: "Ad Revenue",
        name: "Ad Revenue",
        show: "yes"
      },
      {
        title: "Organic Revenue",
        name: "Organic Revenue",
        show: "yes"
      },
      {
        title: "Direct Revenue",
        name: "Direct Revenue",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Revenue",
        name: "InDirect Revenue", 
        show: isFlipkartV2 ? "no" : "yes"
      },
      ...(isSupermart == 1 ? [
        {
          title: "Add To Basket",
          name: "Add To Basket",
          show: "yes"
        }
      ] : []),
      {
        title: "Total Orders",
        name: "Total Orders",
        show: "yes"
      },
      {
        title: "Ad Orders",
        name: "Ad Orders",
        show: "yes"
      },
      {
        title: "Organic Orders",
        name: "Organic Orders",
        show: "yes"
      },
      {
        title: "Direct Orders",
        name: "Direct Orders",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Orders",
        name: "InDirect Orders",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      ...(isSupermart == 2 ? [
        {
          title: "Actions",
          name: "Actions",
          show: "yes"
        }
      ] : []),
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      ...(isSupermart == 1 ? [
        {
          title: "CPB",
          name: "CPB",
          show: "yes"
        }
      ] : []),
      {
        title: "Ad CPA",
        name: "Ad CPA",
        show: "yes"
      },
      {
        title: "Direct CPA",
        name: "Direct CPA",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect CPA",
        name: "InDirect CPA",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Total ROAS",
        name: "Total ROAS",
        show: "yes"
      },
      {
        title: "Ad ROAS",
        name: "Ad ROAS",
        show: "yes"
      },
      {
        title: "Direct ROAS",
        name: "Direct ROAS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect ROAS",
        name: "InDirect ROAS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Ad AOV",
        name: "Ad AOV",
        show: "yes"
      },
      {
        title: "Direct AOV",
        name: "Direct AOV",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect AOV",
        name: "InDirect AOV",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "Total ACOS %",
        name: "Total ACOS %",
        show: "yes"
      },
      {
        title: "Ad ACOS %",
        name: "Ad ACOS %",
        show: "yes"
      },
      {
        title: "Direct ACOS",
        name: "Direct ACOS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect ACOS",
        name: "InDirect ACOS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Total Rev %",
        name: "Total Rev %",
        show: "yes"
      },
      {
        title: "Ad Rev %",
        name: "Ad Rev %",
        show: "yes"
      },
      {
        title: "Direct Rev %",
        name: "Direct Rev %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Rev %",
        name: "InDirect Rev %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Ad CR %",
        name: "Ad CR %",
        show: "yes"
      },
      {
        title: "Direct CR %",
        name: "Direct CR %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect CR %",
        name: "InDirect CR %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      }
    ];
  }

  if (isMyntra) {
    return [
      {
        title: "Spend",
        name: "Spend", 
        show: "yes"
      },
      {
        title: "Total Revenue",
        name: "Total Revenue",
        show: "yes"
      },
      // {
      //   title: "Ad Revenue",
      //   name: "Ad Revenue",
      //   show: "yes"
      // },
      // {
      //   title: "Organic Revenue",
      //   name: "Organic Revenue",
      //   show: "yes"
      // },
      {
        title: "Direct Revenue",
        name: "Direct Revenue",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Revenue",
        name: "InDirect Revenue", 
        show: isFlipkartV2 ? "no" : "yes"
      },
      ...(isSupermart == 1 ? [
        {
          title: "Add To Basket",
          name: "Add To Basket",
          show: "yes"
        }
      ] : []),
      {
        title: "Total Orders",
        name: "Total Orders",
        show: "yes"
      },
      // {
      //   title: "Ad Orders",
      //   name: "Ad Orders",
      //   show: "yes"
      // },
      // {
      //   title: "Organic Orders",
      //   name: "Organic Orders",
      //   show: "yes"
      // },
      {
        title: "Direct Orders",
        name: "Direct Orders",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Orders",
        name: "InDirect Orders",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      ...(isSupermart == 2 ? [
        {
          title: "Actions",
          name: "Actions",
          show: "yes"
        }
      ] : []),
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      ...(isSupermart == 1 ? [
        {
          title: "CPB",
          name: "CPB",
          show: "yes"
        }
      ] : []),
      {
        title: "Total CPA",
        name: "Total CPA",
        show: "yes"
      },
      {
        title: "Ad CPA",
        name: "Ad CPA",
        show: "yes"
      },
      {
        title: "Direct CPA",
        name: "Direct CPA",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect CPA",
        name: "InDirect CPA",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Total ROAS",
        name: "Total ROAS",
        show: "yes"
      },
      {
        title: "Ad ROAS",
        name: "Ad ROAS",
        show: "yes"
      },
      {
        title: "Direct ROAS",
        name: "Direct ROAS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect ROAS",
        name: "InDirect ROAS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Total AOV",
        name: "Total AOV",
        show: "yes"
      },
      {
        title: "Ad AOV",
        name: "Ad AOV",
        show: "yes"
      },
      {
        title: "Direct AOV",
        name: "Direct AOV",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect AOV",
        name: "InDirect AOV",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "Total ACOS %",
        name: "Total ACOS %",
        show: "yes"
      },
      {
        title: "Ad ACOS %",
        name: "Ad ACOS %",
        show: "yes"
      },
      {
        title: "Direct ACOS",
        name: "Direct ACOS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect ACOS",
        name: "InDirect ACOS",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Total Rev %",
        name: "Total Rev %",
        show: "yes"
      },
      {
        title: "Ad Rev %",
        name: "Ad Rev %",
        show: "yes"
      },
      {
        title: "Direct Rev %",
        name: "Direct Rev %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect Rev %",
        name: "InDirect Rev %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "Total CR %",
        name: "Total CR %",
        show: "yes"
      },
      {
        title: "Ad CR %",
        name: "Ad CR %",
        show: "yes"
      },
      {
        title: "Direct CR %",
        name: "Direct CR %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "InDirect CR %",
        name: "InDirect CR %",
        show: isFlipkartV2 ? "no" : "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      }
    ];
  }

  if (isBlinkit) {
    return [
      {
        title: "Spend",
        name: "Spend",
        show: "yes"
      },
      {
        title: "Revenue",
        name: "Revenue",
        show: "yes"
      },
      {
        title: "Orders",
        name: "Orders",
        show: "yes"
      },
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CATC",
        name: "CATC",
        show: "yes"
      },
      {
        title: "CPA",
        name: "CPA",
        show: "yes"
      },
      {
        title: "ROAS",
        name: "ROAS",
        show: "yes"
      },
      {
        title: "AOV",
        name: "AOV",
        show: "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "ATC %",
        name: "ATC %",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "ATC",
        name: "ATC",
        show: "yes"
      },
      {
        title: "ACOS %",
        name: "ACOS %",
        show: "yes"
      },
      {
        title: "CPO",
        name: "CPO",
        show: "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "yes"
      },
      {
        title: "CR %",
        name: "CR %",
        show: "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      }
    ];
  }

  if (isAmazonTargeting) {
    return [
      {
        title: "IS %",
        name: "IS %",
        show: "yes"
      },
      {
        title: "IR",
        name: "IR",
        show: "yes"
      },
      {
        title: "Spend",
        name: "Spend",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
        {
          title: "Total Revenue",
          name: "Total Revenue",
          show: "yes"
        },
      ]),
      {
        title: "Revenue",
        name: "Revenue",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Organic Revenue",
        name: "Organic Revenue",
        show: "yes"
      },
      {
        title: "Inventory",
        name: "Inventory",
        show: "yes"
      },
      {
        title: "Total Orders",
        name: "Total Orders",
        show: "yes"
      },
      ]),
      {
        title: "Orders",
        name: "Orders",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Organic Orders",
        name: "Organic Orders",
        show: "yes"
      },
      ]),
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CPA",
        name: "CPA",
        show: "no"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Total ROAS",
        name: "Total ROAS",
        show: "yes"
      },
      ]),
      {
        title: "Ad ROAS",
        name: "Ad ROAS",
        show: "yes"
      },
      {
        title: "Organic ROAS",
        name: "Organic ROAS",
        show: "yes"
      },
      {
        title: "AOV",
        name: "AOV",
        show: "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "no"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Total ACOS %",
        name: "Total ACOS %",
        show: "yes"
      },
      ]),
      {
        title: "Ad ACOS %",
        name: "Ad ACOS %",
        show: "yes"
      },
      {
        title: "Organic ACOS %",
        name: "Organic ACOS %",
        show: "yes"
      },
      {
        title: "RPC",
        name: "RPC",
        show: "no"
      },
      {
        title: "CPO",
        name: "CPO",
        show: "no"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "no"
      },
      {
        title: "CR %",
        name: "CR %",
        show: "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      },
      {
        title: "Days Left",
        name: "days_left",
        show: "yes"
      },
      {
        title: "DPV",
        name: "Dpv",
        show: "no"
      },
      {
        title: "Viewable Impressions",
        name: "Viewable Impressions",
        show: "no"
      },
      {
        title: "Video First Quartile",
        name: "Video First Quartile",
        show: "no"
      },
      {
        title: "Video Midpoint",
        name: "Video Midpoint",
        show: "no"
      },
      {
        title: "Video Third Quartile",
        name: "Video Third Quartile",
        show: "no"
      },
      {
        title: "Video Complete",
        name: "Video Complete",
        show: "no"
      },
      {
        title: "Video Unmute",
        name: "Video Unmute",
        show: "no"
      },
      {
        title: "VTR",
        name: "Vtr",
        show: "no"
      },
      {
        title: "VCTR",
        name: "Vctr",
        show: "no"
      },
      {
        title: "NTB Order",
        name: "NTB Order",
        show: "no"
      },
      {
        title: "NTB Order %",
        name: "NTB Order %",
        show: "no"
      },
      {
        title: "NTB Sales",
        name: "NTB Sales",
        show: "no"
      },
      {
        title: "NTB Sales %",
        name: "NTB Sales %",
        show: "no"
      }
    ];
  }

  if (isInstamart) {
    return [
      {
        title: "Budget",
        name: "Budget",
        show: "yes"
      },
      {
        title: "Total Spend",
        name: "Total Spend",
        show: "yes"
      },
      {
        title: "Revenue",
        name: "Revenue",
        show: "yes"
      },
      {
        title: "Impressions",
        name: "Impressions",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "CTR %",
        name: "CTR %",
        show: "yes"
      },
      {
        title: "ROAS",
        name: "ROAS",
        show: "yes"
      },
      {
        title: "Add To Cart",
        name: "Add To Cart",
        show: "yes"
      },
      {
        title: "ATC %",
        name: "ATC %",
        show: "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      }
    ];
  }

  if (isAmazonMarketing) {
    return [
      {
        title: "Spend",
        name: "Spend",
        show: "yes"
      },
      {
        title: "Revenue",
        name: "Revenue",
        show: "yes"
      },
      {
        title: "Orders",
        name: "Orders",
        show: "yes"
      },
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CPA",
        name: "CPA",
        show: "yes"
      },
      {
        title: "ROAS",
        name: "ROAS",
        show: "yes"
      },
      {
        title: "Total ROAS",
        name: "Total ROAS",
        show: "yes"
      },
      {
        title: "Ad ROAS",
        name: "Ad ROAS",
        show: "yes"
      },
      {
        title: "AOV",
        name: "AOV",
        show: "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "ACOS %",
        name: "ACOS %",
        show: "yes"
      },
      {
        title: "Ad ACOS %",
        name: "Ad ACOS %",
        show: "yes"
      },
      {
        title: "RPC",
        name: "RPC",
        show: "yes"
      },
      {
        title: "CPO",
        name: "CPO",
        show: "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "yes"
      },
      {
        title: "CR %",
        name: "CR %",
        show: "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      }
    ];
  }

  if (isZepto) {
    return [
      {
        title: "Spend",
        name: "Spend", 
        show: "yes"
      },
      {
        title: "DailyBudget",
        name: "DailyBudget",
        show: "yes"
      },
      {
        title: "Rev",
        name: "Rev",
        show: "yes"
      },
      {
        title: "Orders",
        name: "Orders",
        show: "yes"
      },
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CPA",
        name: "CPA",
        show: "yes"
      },
      {
        title: "ROAS",
        name: "ROAS",
        show: "yes"
      },
      {
        title: "AOV",
        name: "AOV",
        show: "yes"
      },
      {
        title: "CTR",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "yes"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      {
        title: "CPO",
        name: "CPO",
        show: "yes"
      },
      {
        title: "RPC",
        name: "RPC",
        show: "yes"
      },
      {
        title: "ATC",
        name: "ATC",
        show: "yes"
      },
      {
        title: "ACOS",
        name: "ACOS",
        show: "yes"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "yes"
      },  
      {
        title: "CR %",
        name: "CR %",
        show: "yes"
      },
    ];
  }
  if (isBigbasket) {
    return [
      {
        title: "Bidding Price",
        name: "Bidding Price", 
        show: "yes"
      },
      {
        title: "GST",
        name: "GST",
        show: "yes"
      },
      {
        title: "Final Price",
        name: "Final Price",
        show: "yes"
      },
    ];
  }
  
  if (isAmazonSQP) {
  return [
      // Ad metrics
      { title: "Ad Spends", name: "Ad Spends", show: "yes" },
      { title: "Ad ROAS", name: "Ad ROAS", show: "yes" },
      { title: "Ad ACOS %", name: "Ad ACOS %", show: "yes" },
      
      // SQP metrics
      { title: "T-Query", name: "T-Query", show: "yes" },
      // { title: "T-Volume", name: "T-Volume", show: "yes" },
      { title: "T-Imp", name: "T-Imp", show: "yes" },
      { title: "B-Imp", name: "B-Imp", show: "yes" },
      
      // Ad metrics
      { title: "Ad-Imp", name: "Ad-Imp", show: "no" },
      
      // SQP metrics
      { title: "B-IS %", name: "B-IS %", show: "yes" },
      
      // Ad metrics
      { title: "Ad B-IS %", name: "Ad B-IS %", show: "no" },
      { title: "Ad IR", name: "Ad IR", show: "no" },
      
      // SQP metrics
      { title: "T-Clicks", name: "T-Clicks", show: "yes" },
      { title: "B-Clicks", name: "B-Clicks", show: "yes" },
      { title: "B-CS %", name: "B-CS %", show: "yes" },
      
      // Ad metrics
      { title: "Ad-Clicks", name: "Ad-Clicks", show: "no" },
      { title: "Ad-CPC", name: "Ad-CPC", show: "yes" },
      
      // SQP metrics
      { title: "Cat-CTR %", name: "Cat-CTR %", show: "yes" },
      { title: "B-CTR %", name: "B-CTR %", show: "yes" },
      
      // Ad metrics
      { title: "Ad-CTR %", name: "Ad-CTR %", show: "no" },
      
      // SQP metrics
      { title: "T-ATC", name: "T-ATC", show: "yes" },
      { title: "B-ATC", name: "B-ATC", show: "yes" },
      { title: "B-ATCS %", name: "B-ATCS %", show: "yes" },
      { title: "Cat-ATC %", name: "Cat-ATC %", show: "yes" },
      { title: "B-ATC %", name: "B-ATC %", show: "yes" },
      
      // SQP metrics
      { title: "T-Orders", name: "T-Orders", show: "yes" },
      { title: "B-Orders", name: "B-Orders", show: "yes" },
      
      // Ad metrics
      { title: "Ad Orders", name: "Ad Orders", show: "no" },
      
      // SQP metrics
      { title: "B-OS %", name: "B-OS %", show: "yes" },
      { title: "Cat-CR %", name: "Cat-CR %", show: "yes" },
      { title: "B-CR %", name: "B-CR %", show: "yes" },
      
      // Ad metrics
      { title: "Ad-CR %", name: "Ad-CR %", show: "no" },
      
      // SQP metrics
      { title: "T-AOV", name: "T-AOV", show: "yes" },
      { title: "B-AOV", name: "B-AOV", show: "yes" },
      
      // Ad metrics
      { title: "Ad-AOV", name: "Ad-AOV", show: "no" }
    ]
  }

  if (isAmazonRanking) {
    return [
      {
        title: "Avg. Ad Rank",
        name: "Avg. Ad Rank",
        show: "yes"
      },
      {
        title: "Avg. Organic Rank",
        name: "Avg. Organic Rank",
        show: "yes"
      },
      {
        title: "Best Seller",
        name: "Best Seller",
        show: "yes"
      },
      {
        title: "Avg Ad IS%",
        name: "Avg Ad IS%",
        show: "yes"
      },
      {
        title: "Avg Organic IS%",
        name: "Avg Organic IS%",
        show: "yes"
      },
      {
        title: "Campaign Types",
        name: "Campaign Types",
        show: "yes"
      },
      {
        title: "IS %",
        name: "IS %",
        show: "yes"
      },
      {
        title: "IR",
        name: "IR",
        show: "yes"
      },
      {
        title: "Spend",
        name: "Spend",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
        {
          title: "Total Revenue",
          name: "Total Revenue",
          show: "yes"
        },
      ]),
      {
        title: "Revenue",
        name: "Revenue",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Organic Revenue",
        name: "Organic Revenue",
        show: "yes"
      },
      {
        title: "Inventory",
        name: "Inventory",
        show: "yes"
      },
      {
        title: "Total Orders",
        name: "Total Orders",
        show: "yes"
      },
      ]),
      {
        title: "Orders",
        name: "Orders",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Organic Orders",
        name: "Organic Orders",
        show: "yes"
      },
      ]),
      {
        title: "Impression",
        name: "Impression",
        show: "yes"
      },
      {
        title: "Clicks",
        name: "Clicks",
        show: "yes"
      },
      {
        title: "CPA",
        name: "CPA",
        show: "no"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Total ROAS",
        name: "Total ROAS",
        show: "yes"
      },
      ]),
      {
        title: "Ad ROAS",
        name: "Ad ROAS",
        show: "yes"
      },
      {
        title: "Organic ROAS",
        name: "Organic ROAS",
        show: "yes"
      },
      {
        title: "AOV",
        name: "AOV",
        show: "yes"
      },
      {
        title: "CTR %",
        name: "CTR",
        show: "yes"
      },
      {
        title: "CPM",
        name: "CPM",
        show: "no"
      },
      {
        title: "CPC",
        name: "CPC",
        show: "yes"
      },
      ...(Is_Remove_SCVC_Columns.includes(amazonProfileId) ? [] : [
      {
        title: "Total ACOS %",
        name: "Total ACOS %",
        show: "yes"
      },
      ]),
      {
        title: "Ad ACOS %",
        name: "Ad ACOS %",
        show: "yes"
      },
      {
        title: "Organic ACOS %",
        name: "Organic ACOS %",
        show: "yes"
      },
      {
        title: "RPC",
        name: "RPC",
        show: "no"
      },
      {
        title: "CPO",
        name: "CPO",
        show: "no"
      },
      {
        title: "Spend %",
        name: "Spend %",
        show: "yes"
      },
      {
        title: "Rev %",
        name: "Rev %",
        show: "no"
      },
      {
        title: "CR %",
        name: "CR %",
        show: "yes"
      },
      {
        title: "CC",
        name: "CC",
        show: "yes"
      },
      {
        title: "DPV",
        name: "Dpv",
        show: "no"
      },
      {
        title: "Viewable Impressions",
        name: "Viewable Impressions",
        show: "no"
      },
      {
        title: "Video First Quartile",
        name: "Video First Quartile",
        show: "no"
      },
      {
        title: "Video Midpoint",
        name: "Video Midpoint",
        show: "no"
      },
      {
        title: "Video Third Quartile",
        name: "Video Third Quartile",
        show: "no"
      },
      {
        title: "Video Complete",
        name: "Video Complete",
        show: "no"
      },
      {
        title: "Video Unmute",
        name: "Video Unmute",
        show: "no"
      },
      {
        title: "VTR",
        name: "Vtr",
        show: "no"
      },
      {
        title: "VCTR",
        name: "Vctr",
        show: "no"
      },
      {
        title: "NTB Order",
        name: "NTB Order",
        show: "no"
      },
      {
        title: "NTB Order %",
        name: "NTB Order %",
        show: "no"
      },
      {
        title: "NTB Sales",
        name: "NTB Sales",
        show: "no"
      },
      {
        title: "NTB Sales %",
        name: "NTB Sales %",
        show: "no"
      }
    ];
  }

  return [];
};

export const CustomRound = (number, from = 0) => {
  const decimalPart = number - Math.floor(number); // Get the decimal part of the number
  if (decimalPart > 0.5) {
    return Math.ceil(number); // Round up to the nearest integer
  } else {
    if(from == 1 && number >= 99) {
      return parseInt(number)
    }
    return number; // Round down to the nearest integer
  }
}

export const findColumnType = (metricName, table) => {
  const dictionary = table === 1 ? KPI_DICTIONARY_TABLE : KPI_DICTIONARY
  const columnType = dictionary.find(
    (kpi_dic_row) => kpi_dic_row.columns.map((column) => column.toLowerCase().trim()).indexOf(metricName.toLowerCase()) > -1
  );
  return columnType ? columnType : { column_type: 'number' };
};

const getProfile = window.location.href.indexOf('/blinkit') > -1 ? JSON.parse(sessionStorage.getItem('blinkitProfile')) : window.location.href.indexOf('/myntra') > -1 ? JSON.parse(sessionStorage.getItem('myntraProfile')) : window.location.href.indexOf('/flipkart') > -1 ? JSON.parse(sessionStorage.getItem('flipkartProfile')) :window.location.href.indexOf('/instamart') > -1 ? JSON.parse(sessionStorage.getItem('instamartProfile'))  : window.location.href.indexOf('/zepto') > -1 ? JSON.parse(sessionStorage.getItem('zeptoProfile')) : window.location.href.indexOf('/bigbasket') > -1 ? JSON.parse(sessionStorage.getItem('bigbasketProfile')) : JSON.parse(sessionStorage.getItem('selectedProfileId'));

const intlFormat = (num) => {
  return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
};

export const kpiFormattedValue = (currencyIcon = '', metricValue, unit) => {
  const kpiRef = unit == 'number' ? 'Clicks' : unit == 'decimal' ? 'CPA' : unit == 'decimal_currency' ? 'AOV' : unit == 'currency' ? 'Spend' : unit == 'percentage' ? 'CR_perc' : 'Impressions'
  const value = kpiFormatter(metricValue, kpiRef, 1, '');
  return value;
}

const doNotRoundOfNumbers = (metricName) => {
  if(window.location.href.indexOf('/amazon-ranking-configuration') > -1 || window.location.href.indexOf('/amazon-ranking-activity') > -1 || window.location.href.indexOf('/amazon-ranking-billing-payments') > -1) {
    return true;
  }
  return false;
};
// window.location.href.indexOf('/search-query-performance') > -1 && ['Spend'].includes(metricName) == false

export const kpiFormatter = (value, metricName = '', table = 0, custom = '') => {
  const getCurrProfile = window.location.href.indexOf('/blinkit') > -1 ? JSON.parse(sessionStorage.getItem('blinkitProfile')) : window.location.href.indexOf('/myntra') > -1 ? JSON.parse(sessionStorage.getItem('myntraProfile')) : window.location.href.indexOf('/flipkart') > -1 ? JSON.parse(sessionStorage.getItem('flipkartProfile')) :window.location.href.indexOf('/instamart') > -1 ? JSON.parse(sessionStorage.getItem('instamartProfile'))  : window.location.href.indexOf('/zepto') > -1 ? JSON.parse(sessionStorage.getItem('zeptoProfile')) : window.location.href.indexOf('/bigbasket') > -1 ? JSON.parse(sessionStorage.getItem('bigbasketProfile')) : JSON.parse(sessionStorage.getItem('selectedProfileId'));
  if(value === 'get_currency_sign') {
    return getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR")
  }

  if(metricName === 'account_decimal_currency') {
    return (
      Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : Math.round(value, 1)).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile?.countryCode : "IN"}`) 
    );
  }

  if (metricName === 'decimal_number') {
    if (Math.abs(value) <= 99) {
      return (
        Number(value).toFixed(2).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
      );
    }
    return (
      Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : CustomRound(value, 1)).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
    );
  }

  const kpiInfo = findColumnType(metricName, table);

  const { column_type } = kpiInfo;

  if(isNull(value) || isNaN(value)) {
    return `${column_type === 'currency' ? getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR") : ''}` + 0 +  `${column_type === 'percentage' ? '%' : ''}`
  }
  if(metricName === 'wallet_decimal_currency') {
    
    return (
      getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR") +
      Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : Math.round(value, 1)).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile?.countryCode : "IN"}`) 
    );
  }
  if(column_type === 'decimal_currency') {
    if(Math.abs(value) <= 99) {
      return (
        `${getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR")}` +
        Number(value).toFixed(2).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
      );
    }
    
    return (
      `${getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR")}` +
      Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : CustomRound(value, 1)).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
    );
  }

  if (column_type === 'currency' || column_type === 'number') {
    // !(value <= 0)
    // console.log("getProfile", getProfile)
    return column_type === 'currency' && Math.abs(value) <= 99
      ? `${column_type === 'currency' ? getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR") : ''}` + Number(value).toFixed(2).toLocaleString(`en-${getCurrProfile?.currencyCode ? getCurrProfile.countryCode : "IN"}`) :
      `${column_type === 'currency' ? getCurrency(getCurrProfile?.currencyCode ? getCurrProfile?.currencyCode : "INR") : ''}` +
      Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : parseInt(value)).toLocaleString(`en-${getCurrProfile?.currencyCode ? getCurrProfile.countryCode : "IN"}`
    );
  } else if (column_type === 'decimal') {
    return Math.abs(value) >= 99
      ? Number(doNotRoundOfNumbers ? Number(value).toFixed(2) : parseInt(value)).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
      : Number(value).toFixed(2).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)
  } else if (column_type === 'percentage') {
    if(custom == 'custom_percentage') { 
       return `${Number(value).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)} %` 
    }
    if (value > -99 && value < 99) {
      return `${Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : (Math.round(value * 100) / 100)).toFixed(2).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)} %`;
    } else {
      return `${Number(doNotRoundOfNumbers(metricName) ? Number(value).toFixed(2) : (Math.round(value * 100) / 100)).toFixed(0).toLocaleString(`en-${getCurrProfile?.countryCode ? getCurrProfile.countryCode : "IN"}`)} %`;
    }
    // return `${Number((Math.round(value * 100) / 100)).toFixed(2)} %`
    // return Number(value) >= 10 ? parseInt(value) + '%' : Number((Math.round(value * 100) / 100)).toFixed(2) + '%';
  }

  return value;
};

export const TARGETING_REPORTS =
  window.location.href.indexOf('amazon') > -1
  ? [
      {
        report_id: 'targeting',
        report_title: 'Targeting'
      }
    ]
  : window.location.href.indexOf('flipkart') > -1
    ? [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        }
      ]
  : window.location.href.indexOf('instamart') > -1
    ? [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        }
      ]
    :  window.location.href.indexOf('myntra') > -1
    ? [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        }
      ]
    :  window.location.href.indexOf('blinkit') > -1
    ? [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        }
      ] 
      :  window.location.href.indexOf('zepto') > -1
    ? [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        }
      ] 
      :  window.location.href.indexOf('bigbasket') > -1
      ? [
          {
            report_id: 'targeting',
            report_title: 'Targeting'
          }
      ] : [
        {
          report_id: 'targeting',
          report_title: 'Targeting'
        },
        {
          report_id: 'search-term',
          report_title: 'Search Term'
        },
        {
          report_id: 'placement',
          report_title: 'Placement Summary'
        },
        {
          report_id: 'advertised-product',
          report_title: 'Advertised Product Summary'
        }
      ];
